import React, { Component } from 'react'
import styles from './index.css'
import SVG from '../../components/SVG'
import awardIcon from '../../assets/icon-award.svg'
import likeIcon from '../../assets/likeidea.svg'
import unLikeIcon from '../../assets/unlikeidea.svg'
import { formatNumber, universalOpenUrl, universalDispatch } from '../../utils'
import IdeaContent from './IdeaContent'
import { likeIdeaItem } from '../../services'

export default class IdeaItem extends Component {
  constructor(props) {
    super(props)
    const { data: { clapType, clapCount } } = props
    this.state = {
      like: clapType,
      likeCount: clapCount,
    }
  }

  goHomePage = urlToken => {
    universalOpenUrl(`https://www.zhihu.com/people/${urlToken}`)
  }

  switchlikeItem = () => {
    const { like, likeCount } = this.state
    const { data: { pinId } } = this.props
    universalDispatch(() => {
      this.setState(
        {
          like: !like,
          likeCount: !like ? likeCount + 1 : likeCount - 1,
        },
        () => likeIdeaItem(pinId, !like)
      )
    })
  }

  render() {
    const {
      data: {
        userImage,
        userName,
        urlToken,
        createTime,
        content,
        pinType,
        organizationName,
      },
    } = this.props
    const { like, likeCount } = this.state
    return (
      <div className={styles.IdeaItemCard}>
        <div className={styles.IdeaItemLeft}>
          <div onClick={() => this.goHomePage(urlToken)}>
            <img src={userImage} alt="头像" />
          </div>
        </div>
        <div className={styles.IdeaItemRight}>
          <div className={styles.IdeaItemRightHead}>
            <div>
              <div className={styles.LeftName}>{userName}</div>
              <div className={styles.LeftTime}>{createTime}</div>
            </div>
            {pinType === 2 && (
              <div className={styles.Right}>
                <SVG src={awardIcon} width={14} height={14} />
                <span>获奖讨论</span>
              </div>
            )}
          </div>
          <IdeaContent {...content} />
          <div className={styles.IdeaItemRightLike}>
            <div onClick={this.switchlikeItem}>
              <SVG src={like ? likeIcon : unLikeIcon} width={20} height={20} />
            </div>
            {formatNumber(likeCount)}
          </div>
          {pinType === 2 && (
            <div className={styles.IdeaItemRightAward}>
              <span>「{organizationName}」</span>负责评选并赞助奖品
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/IdeaItem/index.js